export const GET_CORRESPONDENCE_CATEGORIES = "GET_CORRESPONDENCE_CATEGORIES";
export const GET_CORRESPONDENCE = "GET_CORRESPONDENCE";
export const GET_TASK_CORRESPONDENCE = "GET_TASK_CORRESPONDENCE";
export const GET_TASKMAP_CORRESPONDENCE = "GET_TASKMAP_CORRESPONDENCE";
export const ADD_BOARD_CORRESPONDENCE = "ADD_BOARD_CORRESPONDENCE";
export const EDIT_BOARD_CORRESPONDENCE = "EDIT_BOARD_CORRESPONDENCE";
export const DELETE_BOARD_CORRESPONDENCE = "DELETE_BOARD_CORRESPONDENCE";
export const GET_BOARD_CONTRACTS = "GET_BOARD_CONTRACTS";
export const GET_BOARD_EXPIRING_CONTRACTS = "GET_BOARD_EXPIRING_CONTRACTS";
